"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdobeTagManager = void 0;
const tslib_1 = require("tslib");
const adobe_tag_manager_1 = tslib_1.__importDefault(require("./adobe-tag-manager"));
exports.AdobeTagManager = adobe_tag_manager_1.default;
//# sourceMappingURL=index.js.map